module.exports = __webpack_public_path__ + "static/img/bg-fr.6d2db93b.webp";